import api from '../../utils/api';

export interface SymptomMappingRow {
  id: number;
  normalized_symptom: string;
  speciality_id: string;
  created_at: string;
  speciality?: {
    id: string;
    name: string;
  };
  keywords: string[];
}

export interface GetSymptomMappingsParams {
  page?: number;
  limit?: number;
  search?: string;
}

export interface GetSymptomMappingsResponse {
  success: boolean;
  data: {
    mappings: SymptomMappingRow[];
    pagination: {
      total: number;
      page: number;
      limit: number;
      pages: number;
    };
  };
}

export interface GetNormalizedSymptomsResponse {
  success: boolean;
  data: string[];
}

export interface SpecialityDropdownItem {
  id: string;
  name: string;
}

export interface GetSpecialitiesResponse {
  success: boolean;
  data: SpecialityDropdownItem[];
}

export interface CreateMappingPayload {
  normalized_symptom: string;
  speciality_id: string;
  keywords: string[];
}

export interface SaveMappingResponse {
  success: boolean;
  message?: string;
  data: SymptomMappingRow;
}

export interface DeleteMappingResponse {
  success: boolean;
  message?: string;
}

export async function getSymptomMappings(params: GetSymptomMappingsParams = {}): Promise<GetSymptomMappingsResponse> {
  const searchParams = new URLSearchParams();
  if (params.page != null) searchParams.set('page', String(params.page));
  if (params.limit != null) searchParams.set('limit', String(params.limit));
  if (params.search) searchParams.set('search', params.search);
  const qs = searchParams.toString();
  const response = await api.get<GetSymptomMappingsResponse>(`/master-admin/symptom-mappings${qs ? `?${qs}` : ''}`);
  return response.data;
}

export async function getNormalizedSymptoms(): Promise<GetNormalizedSymptomsResponse> {
  const response = await api.get<GetNormalizedSymptomsResponse>('/master-admin/symptom-mappings/normalized-symptoms');
  return response.data;
}

export async function getSpecialities(): Promise<GetSpecialitiesResponse> {
  const response = await api.get<GetSpecialitiesResponse>('/master-admin/symptom-mappings/specialities');
  return response.data;
}

export async function createSymptomMapping(payload: CreateMappingPayload): Promise<SaveMappingResponse> {
  const response = await api.post<SaveMappingResponse>('/master-admin/symptom-mappings', payload);
  return response.data;
}

export async function updateSymptomMapping(
  id: number | string,
  payload: Partial<CreateMappingPayload>
): Promise<SaveMappingResponse> {
  const response = await api.put<SaveMappingResponse>(`/master-admin/symptom-mappings/${id}`, payload);
  return response.data;
}

export async function deleteSymptomMapping(id: number | string): Promise<DeleteMappingResponse> {
  const response = await api.delete<DeleteMappingResponse>(`/master-admin/symptom-mappings/${id}`);
  return response.data;
}
